.d2j5lh0 {
  display: inline-flex;
  width: 100%;
  min-width: 0;
  cursor: default;
}
.d2j5lh0 > * {
  pointer-events: none;
}